<div
    *ngIf="wire"
    class="agpr-fakeBlock agpr-contextMenu-parent"
    [ngClass]="{
        'agpr-fakeBlock-editable': editable,
        'agpr-fakeBlock-editing': editing,
        'agpr-fakeBlock-renderable': renderable && !editing
    }"
    (agprClickUnless)="emitClick()"
    [agprClickUnlessSelectors]="['button']"
>
    <ul role="group" [attr.aria-label]="placeholder | localize" [attr.aria-describedby]="errorsId">
        <ul
            role="menu"
            class="agpr-contextMenu top right"
            [attr.aria-label]="'PageBuilder.blockMenu.edit' | localize"
        >
            <li role="menuitem">
                <agpr-button
                    [id]="id + '_edit'"
                    *ngIf="editable"
                    icon="fa-regular fa-duotone fa-pen"
                    (click)="emitClick()"
                    tooltip="Amplify.fakeBlockType.companyLogo.edit"
                    [style]="buttonTypes.contextMenu"
                ></agpr-button>
            </li>
            <li role="menuitem">
                <agpr-button
                    [id]="id + '_delete'"
                    *ngIf="editable"
                    icon="fa-regular fa-duotone fa-trash-can"
                    (click)="deleteBlock()"
                    tooltip="Amplify.fakeBlockType.companyLogo.delete"
                    [style]="buttonTypes.contextMenu"
                ></agpr-button>
            </li>
        </ul>
        <ng-container
            *ngIf="_wireBlockType === blockTypes.companyAddress"
            class="agpr-inlineAdder"
        >
            <ul role="menu" [attr.aria-label]="'PageBuilder.blockMenu.add' | localize">
                <li role="menuitem">
                    <agpr-button
                        class="agpr-inlineAdder-topButton"
                        [id]="id + '_addTop'"
                        (click)="inlineAddToggle()"
                        agprTooltip="Amplify.fakeBlockType.addBlock"
                        tooltipPosition="top"
                        [style]="buttonTypes.contextMenu"
                        [icon]="'fa-regular fa-plus'"
                    >
                        <span
                            class="agpr-inlineAdder-topButton-icon fa-regular fa-duotone fa-plus"
                            aria-hidden="true"
                        ></span>
                    </agpr-button>
                    <div
                        *ngIf="inlineAdderVisible"
                        class="agpr-inlineAdder-panel"
                        (mouseleave)="inlineAdderVisible = false"
                        (focusout)="leaveBlockAdder($event)"
                    >
                        <agpr-block-adder
                            [id]="fakeBlockAdderId"
                            (blockAdded)="inlineAddToggle()"
                        ></agpr-block-adder>
                    </div>
                </li>
            </ul>
        </ng-container>
    </ul>
    <div class="agpr-fakeBlock-content">
        <div *ngIf="renderable">
            <agpr-twig
                class="agpr-block-rendered"
                [twigTemplate]="twigTemplate"
                [data]="twigData"
                [id]="id + '_wireFakeBlock_Renderable_twig'"
            ></agpr-twig>
        </div>
        <div
            *ngIf="!renderable"
            class='agpr-fakeBlock-placeholder'
        >
            <span
                [ngClass]="icon"
                class="agpr-fakeBlock-placeholderIcon"
                [style.height]="height + 'px'"
                [style.line-height]="height + 'px'"
            ></span>
            <span
                class="agpr-fakeBlock-placeholderLabel"
                [ngClass]="{'agpr-fakeBlock-placeholderLabel-companyLogo': _wireBlockType === blockTypes.companyLogo}"
            >
                {{ placeholder | localize }}
            </span>
        </div>
    </div>
</div>
